import React from 'react';
import { ChatWorkspaceTopBar } from '../../../workspace/index.js';
import { useLocale } from '../../../locale/provider';

export default function ChatTopBarSection({
  hasConversationStarted,
  projectSlot,
  projectNameEditing,
  projectNameDraft,
  setProjectNameDraft,
  handleProjectNameSave,
  handleProjectNameCancel,
  resolvedProjectDisplayName,
  handleProjectNameStartEdit,
  activeWorkspaceTab,
  setActiveWorkspaceTab,
  themeTokens,
  resolvedUILabels,
  hasSessionDigest,
  resolvedSessionDigest,
  knowledgeHubPopoverContent,
  knowledgeHubPopoverOpen,
  handleKnowledgeHubOpenChange,
  handleOpenKnowledgeHub,
  workspaceOpenButtonVisible = false,
  showCanvasPanel,
  handleToggleWorkspacePanel,
  isCompactLayout,
  showSidebarMenuButton,
  handleOpenSidebarMenu,
  showWorkspaceTabSwitch = true,
  onBackToProject,
}) {
  const labels = useLocale();
  return (
    <ChatWorkspaceTopBar
      hasConversationStarted={hasConversationStarted}
      projectSlot={projectSlot}
      projectNameEditing={projectNameEditing}
      projectNameDraft={projectNameDraft}
      setProjectNameDraft={setProjectNameDraft}
      handleProjectNameSave={handleProjectNameSave}
      handleProjectNameCancel={handleProjectNameCancel}
      resolvedProjectDisplayName={resolvedProjectDisplayName}
      handleProjectNameStartEdit={handleProjectNameStartEdit}
      isCompactLayout={isCompactLayout}
      activeWorkspaceTab={activeWorkspaceTab}
      setActiveWorkspaceTab={setActiveWorkspaceTab}
      segmentedThemeStyle={{}}
      themeTokens={themeTokens}
      resolvedUILabels={resolvedUILabels}
      resolvedProductName={resolvedProjectDisplayName}
      customerRoleFallback={resolvedUILabels?.customer_role_fallback ?? labels.customer_role_fallback}
      hasSessionDigest={hasSessionDigest}
      resolvedSessionDigest={resolvedSessionDigest}
      knowledgeHubPopoverContent={knowledgeHubPopoverContent}
      knowledgeHubPopoverOpen={knowledgeHubPopoverOpen}
      handleKnowledgeHubOpenChange={handleKnowledgeHubOpenChange}
      handleOpenKnowledgeHub={handleOpenKnowledgeHub}
      workspaceOpenButtonVisible={workspaceOpenButtonVisible}
      hasUnseenWorkspaceUpdate={false}
      showCanvasPanel={showCanvasPanel}
      handleToggleWorkspacePanel={handleToggleWorkspacePanel}
      showSidebarMenuButton={showSidebarMenuButton}
      handleOpenSidebarMenu={handleOpenSidebarMenu}
      showWorkspaceTabSwitch={showWorkspaceTabSwitch}
      onBackToProject={onBackToProject}
    />
  );
}
